import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const badges = [
    { icon: '🏥', text: 'NABH Ready' },
    { icon: '🔒', text: 'HIPAA Compliant' },
    { icon: '✅', text: 'GST Compliant' },
  ];

  const trustFeatures = [
    'HIPAA & NABH Compliant',
    '24/7 Cloud Support',
    'Real-time Analytics',
    'Free Data Migration',
  ];

  return (
    <section id="hero" className="hero">
      <Helmet>
        <title>Mediway Nextgen — #1 Hospital Management System India</title>
        <meta name="description" content="Mediway Nextgen is India's trusted Hospital Management System (HMS) for OPD & IPD management, NABH billing, EMR, and real-time analytics. Try free for 30 days." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com" />
        <meta property="og:title" content="Mediway Nextgen — Hospital Management System India" />
        <meta property="og:description" content="Transform care with Mediway Nextgen — hospital ERP, billing, OPD & IPD systems tailored for India." />
        <meta property="og:url" content="https://mediwaynextgen.wayug.com" />
        <meta property="og:image" content="https://mediwaynextgen.wayug.com/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://mediwaynextgen.wayug.com/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="container">
        <div className="hero__content">
          <div className={`hero__text ${isVisible ? 'hero__text--visible' : ''}`}>
            <div className="hero__badge-row">
              {badges.map((b, i) => (
                <span key={i} className="badge badge--pill">
                  {b.icon} {b.text}
                </span>
              ))}
            </div>

            <h1 className="hero__title">
              India's Most Trusted <span className="hero__title-highlight">Hospital Management Software</span> for Modern Healthcare
            </h1>

            <p className="hero__description">
              Streamline patient care, billing, and clinical workflows with the <strong>best HMS India 2025</strong> has to offer. Mediway Nextgen is a premium, secure <strong>hospital management software India</strong> trusts — engineered to act as the perfect <strong>EMR software small hospital</strong> units need, as well as a robust <strong>nursing home software India</strong> standard. Natively integrated with ABDM for complete <strong>HMS software with ABHA integration</strong>, it delivers advanced <strong>NABH software India</strong> compliance and automated <strong>hospital billing software India</strong> capabilities out of the box.
            </p>

            <div className="hero__features">
              {trustFeatures.map((feature, index) => (
                <div key={index} className="hero__feature">
                  <svg className="hero__feature-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="hero__actions">
              <Link to="/contact" className="btn btn-primary hero__cta-primary">
                Start Free Trial — 30 Days
                <svg className="hero__cta-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>

              <Link to="/features" className="btn btn-secondary hero__cta-secondary">
                <svg className="hero__cta-icon" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                </svg>
                Watch Live Demo
              </Link>
            </div>

            <div className="hero__social-proof">
              <div className="hero__stats">
                <div className="hero__stat">
                  <span className="hero__stat-number">5+</span>
                  <span className="hero__stat-label">Hospitals</span>
                </div>
                <div className="hero__stat">
                  <span className="hero__stat-number">10k+</span>
                  <span className="hero__stat-label">Patients Served</span>
                </div>
                <div className="hero__stat">
                  <span className="hero__stat-number">99.9%</span>
                  <span className="hero__stat-label">Uptime SLA</span>
                </div>
                <div className="hero__stat">
                  <span className="hero__stat-number">24/7</span>
                  <span className="hero__stat-label">Support</span>
                </div>
              </div>
            </div>
          </div>

          <div className={`hero__visual ${isVisible ? 'hero__visual--visible' : ''}`}>
            <div className="hero__image-container">
              <div className="hero__dashboard">
                <div className="dashboard__header">
                  <div className="dashboard__brand">
                    <span className="dashboard__dot dashboard__dot--red"></span>
                    <span className="dashboard__dot dashboard__dot--yellow"></span>
                    <span className="dashboard__dot dashboard__dot--green"></span>
                  </div>
                  <div className="dashboard__nav">
                    <div className="nav__item nav__item--active">Dashboard</div>
                    <div className="nav__item">Patients</div>
                    <div className="nav__item">Analytics</div>
                  </div>
                  <div className="dashboard__user">
                    <div className="user__avatar"></div>
                    <div className="user__pulse"></div>
                  </div>
                </div>

                <div className="dashboard__content">
                  <div className="dashboard__cards">
                    <div className="dashboard__card">
                      <div className="card__icon card__icon--patients">👥</div>
                      <div className="card__info">
                        <div className="card__number">2,847</div>
                        <div className="card__label">Active Patients</div>
                        <div className="card__trend card__trend--up">↑ 12% this week</div>
                      </div>
                    </div>

                    <div className="dashboard__card">
                      <div className="card__icon card__icon--appointments">📅</div>
                      <div className="card__info">
                        <div className="card__number">156</div>
                        <div className="card__label">Today's OPD</div>
                        <div className="card__trend card__trend--up">8 pending</div>
                      </div>
                    </div>

                    <div className="dashboard__card">
                      <div className="card__icon card__icon--revenue">💰</div>
                      <div className="card__info">
                        <div className="card__number">₹8.4L</div>
                        <div className="card__label">Monthly Revenue</div>
                        <div className="card__trend card__trend--up">↑ 23%</div>
                      </div>
                    </div>

                    <div className="dashboard__card">
                      <div className="card__icon card__icon--beds">🛏️</div>
                      <div className="card__info">
                        <div className="card__number">84%</div>
                        <div className="card__label">Bed Occupancy</div>
                        <div className="card__trend card__trend--neutral">42/50 beds</div>
                      </div>
                    </div>
                  </div>

                  <div className="dashboard__chart">
                    <div className="chart__header">
                      Patient Flow
                      <span className="chart__live"><span className="chart__live-dot"></span>Live</span>
                    </div>
                    <div className="chart__bars">
                      <div className="chart__bar" style={{ height: '60%' }}><span>Mon</span></div>
                      <div className="chart__bar" style={{ height: '80%' }}><span>Tue</span></div>
                      <div className="chart__bar" style={{ height: '45%' }}><span>Wed</span></div>
                      <div className="chart__bar chart__bar--active" style={{ height: '90%' }}><span>Thu</span></div>
                      <div className="chart__bar" style={{ height: '70%' }}><span>Fri</span></div>
                      <div className="chart__bar" style={{ height: '55%' }}><span>Sat</span></div>
                      <div className="chart__bar" style={{ height: '35%' }}><span>Sun</span></div>
                    </div>
                  </div>

                  <div className="dashboard__notification">
                    <div className="notif__icon">🔔</div>
                    <div className="notif__text">
                      <strong>CGHS Claim Approved</strong> — Patient #4821 · ₹12,400
                    </div>
                    <div className="notif__time">2m ago</div>
                  </div>
                </div>
              </div>

              <div className="hero__floating-elements">
                <div className="floating__element floating__element--1">
                  <div className="element__icon">🏥</div>
                  <div className="element__text">Multi-Location</div>
                </div>
                <div className="floating__element floating__element--2">
                  <div className="element__icon">📊</div>
                  <div className="element__text">Real-time Data</div>
                </div>
                <div className="floating__element floating__element--3">
                  <div className="element__icon">🔒</div>
                  <div className="element__text">HIPAA Secure</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero__background">
        <div className="hero__gradient"></div>
        <div className="hero__pattern"></div>
      </div>
    </section>
  );
};

export default Hero;